import React from 'react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';

import ModalBox from '../../../shared/modal';
import DatePicker from '../../../shared/date-picker/main';

const Form = props => {
	return (
		<div className='payout-requests-register-table-change-date-modal'>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(props.submitAcceptedDate.bind(null, props.row))}
			>
				<div>
					<p>
						This is day <span className="background-lightcoral">BEFORE</span> start!
					</p>
					<br/>
					<Field
						name="date"
						intl={props.intl}
						{...props.datepicker}
						onUpdate={props.datepickerChange}
						component={DatePicker}
						onToggle={props.datepickerToggle}
						onApply={props.datepickerApply}
						maxDate={moment()}
					/>
				</div>
				<br/>
				<button
					className='ui-btn ui-btn-primary apply'
					type='submit'
				>{props.intl('Apply')}</button>
			</form>
		</div>
	);
};

const Main = props =>
	<ModalBox
		title={props.intl('Change accepted day form')}
		body={Form(props)}
		isOpen={props.idOfChangeDateForm === props.row.id}
		onClose={props.toggleChangeDateForm.bind(null, props.row)}
		className='form-modal affiliate-distribution-modal'
	/>;

export default reduxForm({ form: 'formTableScalingChangeAcceptedAt' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-scaling/form.js